export var homeLoans = {
    "home-loans": {
        "id": "13839-df-www",
        "dynamicform": "https://www.newamericanfunding.com/df/home-loans/",
        "templateType": "standard",
        "layout": {
            "templateType": "standard",
            "navGroups": []
        },
        "pages": [
            "13839_loanPurpose"
        ],
        "subFlows": {
            "purchase": {
                "path": "https://www.newamericanfunding.com/df/home-loans/#13839_purchase",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "purchase"
                ],
                "pages": [
                    "13839_loanPurpose",
                    "13798_propertyType",
                    "13795_occupancy",
                    "13797_fthbFlag",
                    "13800_timeframe",
                    "13817_state",
                    "13799_loanAmt_P",
                    "13796_downpayment",
                    "13792_incomeSource",
                    "13784_annualIncome",
                    "13803_proofOfIncome",
                    "13794_militaryServiceFlag",
                    "13785_bankruptcyFlag",
                    "13789_forclosureFlag",
                    "13793_lateMortgagePaymentCount",
                    "13815_hasAgent",
                    "13786_estimateCreditRating",
                    "13791_FirstName&LastName",
                    "13788_Email",
                    "13802_phone"
                ]
            },
            "refinance": {
                "path": "https://www.newamericanfunding.com/df/home-loans/#13839_refinance",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "refinance"
                ],
                "pages": [
                    "13839_loanPurpose",
                    "13816_state",
                    "13812_propertyType",
                    "13795_occupancy",
                    "13814_refiReason",
                    "13811_homeValueAmt",
                    "13805_loanAmt_R",
                    "13807_cashOutAmt",
                    "13794_militaryServiceFlag",
                    "13789_forclosureFlag",
                    "13785_bankruptcyFlag",
                    "13793_lateMortgagePaymentCount",
                    "13792_incomeSource",
                    "13784_annualIncome",
                    "13803_proofOfIncome",
                    "13786_estimateCreditRating",
                    "13790_FirstName&LastName",
                    "13788_Email",
                    "13802_phone"
                ]
            },
            "equity": {
                "path": "https://www.newamericanfunding.com/df/home-loans/#13839_equity",
                "visible": [
                    "equal",
                    "loanPurpose",
                    "equity"
                ],
                "pages": [
                    "13839_loanPurpose",
                    "13816_state",
                    "13813_propertyType",
                    "13811_homeValueAmt",
                    "13804_loanAmt_R",
                    "13806_cashOutAmt",
                    "13808_refiHelocWhy",
                    "13794_militaryServiceFlag",
                    "13789_forclosureFlag",
                    "13785_bankruptcyFlag",
                    "13793_lateMortgagePaymentCount",
                    "13792_incomeSource",
                    "13784_annualIncome",
                    "13803_proofOfIncome",
                    "13786_estimateCreditRating",
                    "13791_FirstName&LastName",
                    "13787_Email",
                    "13801_phone"
                ]
            }
        },
        "templateCollection": {
            "NAF_HomePage": "root",
            "NAF_DynamicForm": "parent",
            "NAF_DynamicFormStandardPage": "standard",
            "NAF_DynamicFormLeftNavPage": "leftnav"
        },
        "pageCollection": {
            "13839_loanPurpose": {
                "title": "Choose your loan type",
                "subtext": "",
                "questions": [
                    "loanPurpose"
                ],
                "category": ""
            },
            "13798_propertyType": {
                "title": "What type of property are you purchasing?",
                "subtext": null,
                "questions": [
                    "13798_propertyType"
                ]
            },
            "13795_occupancy": {
                "title": "How will your property be used?",
                "subtext": null,
                "questions": [
                    "13795_occupancy"
                ]
            },
            "13797_fthbFlag": {
                "title": "Is this your first time buying a home?",
                "subtext": null,
                "questions": [
                    "13797_fthbFlag"
                ]
            },
            "13800_timeframe": {
                "title": "When do you plan to purchase?",
                "subtext": null,
                "questions": [
                    "13800_timeframe"
                ]
            },
            "13817_state": {
                "title": "Where is the property located?",
                "subtext": "We'll get local information for you.",
                "questions": [
                    "13817_state"
                ]
            },
            "13799_loanAmt_P": {
                "title": "What is the estimated purchase price?",
                "subtext": "Just an estimate is fine. You can update the amount later in the process.",
                "questions": [
                    "13799_loanAmt_P"
                ]
            },
            "13796_downpayment": {
                "title": "How much is your down payment?",
                "subtext": "Just an estimate is fine. You can update the amount later in the process.",
                "questions": [
                    "13796_downpayment"
                ]
            },
            "13792_incomeSource": {
                "title": "Are you currently employed?",
                "subtext": null,
                "questions": [
                    "13792_incomeSource"
                ]
            },
            "13784_annualIncome": {
                "title": "What is your gross annual household income?",
                "subtext": null,
                "questions": [
                    "13784_annualIncome"
                ]
            },
            "13803_proofOfIncome": {
                "title": "Can you show proof of income?",
                "subtext": null,
                "questions": [
                    "13803_proofOfIncome"
                ]
            },
            "13794_militaryServiceFlag": {
                "title": "Active or previous U.S. military service?",
                "subtext": null,
                "questions": [
                    "13794_militaryServiceFlag"
                ]
            },
            "13785_bankruptcyFlag": {
                "title": "Any bankruptcy in the past 3 years?",
                "subtext": null,
                "questions": [
                    "13785_bankruptcyFlag"
                ]
            },
            "13789_forclosureFlag": {
                "title": "Any foreclosure in the past 2 years?",
                "subtext": null,
                "questions": [
                    "13789_forclosureFlag"
                ]
            },
            "13793_lateMortgagePaymentCount": {
                "title": "Number of late mortgage payments in the last 12 months?",
                "subtext": null,
                "questions": [
                    "13793_lateMortgagePaymentCount"
                ]
            },
            "13815_hasAgent": {
                "title": "Are you working with a real estate agent?",
                "subtext": null,
                "questions": [
                    "13815_hasAgent"
                ]
            },
            "13786_estimateCreditRating": {
                "title": "How would you rate your credit?",
                "subtext": null,
                "questions": [
                    "13786_estimateCreditRating"
                ]
            },
            "13791_FirstName&LastName": {
                "title": "Please enter your name below",
                "subtext": "<i class=\"fa-solid fa-lock\" aria-hidden=\"true\" style=\"font-size: .875rem; color: #d7b963; padding-right: 5px;\"></i> Your privacy is protected.",
                "questions": [
                    "13791_firstName",
                    "13791_lastName"
                ]
            },
            "13788_Email": {
                "title": "What is your e-mail address?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "questions": [
                    "13788_email"
                ]
            },
            "13802_phone": {
                "title": "What is your phone number?",
                "subtext": "We adhere to a strict privacy policy and will never sell your information.",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "questions": [
                    "13802_phone"
                ]
            },
            "13816_state": {
                "title": "What state is the property located in?",
                "subtext": "We'll get local information for you.",
                "questions": [
                    "13816_state"
                ]
            },
            "13812_propertyType": {
                "title": "What type of home are you refinancing?",
                "subtext": null,
                "questions": [
                    "13812_propertyType"
                ]
            },
            "13814_refiReason": {
                "title": "Why do you want to refinance?",
                "subtext": null,
                "questions": [
                    "13814_refiReason"
                ]
            },
            "13811_homeValueAmt": {
                "title": "What's your home's value?",
                "subtext": "Just an estimate is fine",
                "questions": [
                    "13811_homeValueAmt"
                ]
            },
            "13805_loanAmt_R": {
                "title": "How much do you owe?",
                "subtext": "Just an estimate is fine. You can update the amount later in the process.",
                "questions": [
                    "13805_loanAmt_R"
                ],
                "skipLink": [
                    "true",
                    "Skip - Owned Free and Clear",
                    "Skip - Owned Free and Clear"
                ]
            },
            "13807_cashOutAmt": {
                "title": "How much cash do you want to borrow?",
                "subtext": "Just an estimate is fine. You can update the amount later in the process.",
                "questions": [
                    "13807_cashOutAmt"
                ]
            },
            "13790_FirstName&LastName": {
                "title": "Please enter your name below",
                "subtext": "You can always add a co-borrower or edit this entry later.",
                "questions": [
                    "13790_firstName",
                    "13790_lastName"
                ]
            },
            "13813_propertyType": {
                "title": "What type of property do you have?",
                "subtext": null,
                "questions": [
                    "13813_propertyType"
                ]
            },
            "13804_loanAmt_R": {
                "title": "How much do you owe?",
                "subtext": null,
                "questions": [
                    "13804_loanAmt_R"
                ],
                "skipLink": [
                    "true",
                    "Skip - Owned Free and Clear",
                    "Skip - Owned Free and Clear"
                ]
            },
            "13806_cashOutAmt": {
                "title": "How much cash do you want to borrow?",
                "subtext": null,
                "questions": [
                    "13806_cashOutAmt"
                ]
            },
            "13808_refiHelocWhy": {
                "title": "Why are you accessing home equity?",
                "subtext": null,
                "questions": [
                    "13808_refiHelocWhy"
                ]
            },
            "13787_Email": {
                "title": "What is your e-mail address?",
                "subtext": "<i class=\"fa-solid fa-lock\" aria-hidden=\"true\" style=\"font-size: 12px;color: #d7b963;padding-right: 5px;\"></i>Your privacy is protected. We never sell your information.",
                "questions": [
                    "13787_email"
                ]
            },
            "13801_phone": {
                "title": "What is your phone number?",
                "subtext": "<i class=\"fa-solid fa-lock\" aria-hidden=\"true\" style=\"font-size: 12px;color: #d7b963;padding-right: 5px;\"></i>Your privacy is protected. We never sell your information.",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "questions": [
                    "13801_phone"
                ]
            }
        },
        "questionCollection": {
            "13798_propertyType": {
                "type": "radio",
                "fieldId": "propertyType",
                "answerOptions": [
                    {
                        "text": "Single Family Home",
                        "value": "Single Family Home"
                    },
                    {
                        "text": "Multi-Family Home",
                        "value": "Multi-Family Home"
                    },
                    {
                        "text": "Townhouse / Condo",
                        "value": "Townhouse / Condo"
                    },
                    {
                        "text": "Manufactured Home",
                        "value": "Manufactured Home"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13795_occupancy": {
                "type": "radio",
                "fieldId": "occupancy",
                "answerOptions": [
                    {
                        "text": "Primary Residence",
                        "value": "Primary Residence"
                    },
                    {
                        "text": "Secondary Home",
                        "value": "Secondary Home"
                    },
                    {
                        "text": "Investment Property",
                        "value": "Investment Property"
                    }
                ]
            },
            "13797_fthbFlag": {
                "type": "radio",
                "fieldId": "fthbFlag",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13800_timeframe": {
                "type": "radio",
                "fieldId": "timeframe",
                "answerOptions": [
                    {
                        "text": "Now - I signed a contract",
                        "value": "Now - I signed a contract"
                    },
                    {
                        "text": "Soon - I found a home",
                        "value": "Soon - I found a home"
                    },
                    {
                        "text": "Within 30 days",
                        "value": "Within 30 days"
                    },
                    {
                        "text": "In the next few months",
                        "value": "In the next few months"
                    },
                    {
                        "text": "Not sure - Researching",
                        "value": "Not sure - Researching"
                    }
                ]
            },
            "13817_state": {
                "type": "dropDown",
                "fieldId": "state",
                "labelText": "",
                "customDefaultText": null,
                "answerOptions": [
                    {
                        "text": "Alabama",
                        "value": "AL"
                    },
                    {
                        "text": "Alaska",
                        "value": "AK"
                    },
                    {
                        "text": "Arizona",
                        "value": "AZ"
                    },
                    {
                        "text": "Arkansas",
                        "value": "AR"
                    },
                    {
                        "text": "California",
                        "value": "CA"
                    },
                    {
                        "text": "Colorado",
                        "value": "CO"
                    },
                    {
                        "text": "Connecticut",
                        "value": "CT"
                    },
                    {
                        "text": "Delaware",
                        "value": "DE"
                    },
                    {
                        "text": "District Of Columbia",
                        "value": "DC"
                    },
                    {
                        "text": "Florida",
                        "value": "FL"
                    },
                    {
                        "text": "Georgia",
                        "value": "GA"
                    },
                    {
                        "text": "Hawaii",
                        "value": "HI"
                    },
                    {
                        "text": "Idaho",
                        "value": "ID"
                    },
                    {
                        "text": "Illinois",
                        "value": "IL"
                    },
                    {
                        "text": "Indiana",
                        "value": "IN"
                    },
                    {
                        "text": "Iowa",
                        "value": "IA"
                    },
                    {
                        "text": "Kansas",
                        "value": "KS"
                    },
                    {
                        "text": "Kentucky",
                        "value": "KY"
                    },
                    {
                        "text": "Louisiana",
                        "value": "LA"
                    },
                    {
                        "text": "Maine",
                        "value": "ME"
                    },
                    {
                        "text": "Maryland",
                        "value": "MD"
                    },
                    {
                        "text": "Massachusetts",
                        "value": "MA"
                    },
                    {
                        "text": "Michigan",
                        "value": "MI"
                    },
                    {
                        "text": "Minnesota",
                        "value": "MN"
                    },
                    {
                        "text": "Mississippi",
                        "value": "MS"
                    },
                    {
                        "text": "Missouri",
                        "value": "MO"
                    },
                    {
                        "text": "Montana",
                        "value": "MT"
                    },
                    {
                        "text": "Nebraska",
                        "value": "NE"
                    },
                    {
                        "text": "Nevada",
                        "value": "NV"
                    },
                    {
                        "text": "New Hampshire",
                        "value": "NH"
                    },
                    {
                        "text": "New Jersey",
                        "value": "NJ"
                    },
                    {
                        "text": "New Mexico",
                        "value": "NM"
                    },
                    {
                        "text": "New York",
                        "value": "NY"
                    },
                    {
                        "text": "North Carolina",
                        "value": "NC"
                    },
                    {
                        "text": "North Dakota",
                        "value": "ND"
                    },
                    {
                        "text": "Ohio",
                        "value": "OH"
                    },
                    {
                        "text": "Oklahoma",
                        "value": "OK"
                    },
                    {
                        "text": "Oregon",
                        "value": "OR"
                    },
                    {
                        "text": "Pennsylvania",
                        "value": "PA"
                    },
                    {
                        "text": "Rhode Island",
                        "value": "RI"
                    },
                    {
                        "text": "South Carolina",
                        "value": "SC"
                    },
                    {
                        "text": "South Dakota",
                        "value": "SD"
                    },
                    {
                        "text": "Tennessee",
                        "value": "TN"
                    },
                    {
                        "text": "Texas",
                        "value": "TX"
                    },
                    {
                        "text": "Utah",
                        "value": "UT"
                    },
                    {
                        "text": "Vermont",
                        "value": "VT"
                    },
                    {
                        "text": "Virginia",
                        "value": "VA"
                    },
                    {
                        "text": "Washington",
                        "value": "WA"
                    },
                    {
                        "text": "West Virginia",
                        "value": "WV"
                    },
                    {
                        "text": "Wisconsin",
                        "value": "WI"
                    },
                    {
                        "text": "Wyoming",
                        "value": "WY"
                    }
                ]
            },
            "13799_loanAmt_P": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "loanAmt_P",
                "questionTitle": "What is the estimated purchase price?",
                "includeSlider": true,
                "sliderMinValue": 25000,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "required"
                    ],
                    [
                        "min",
                        25000,
                        "Min: $25,000"
                    ],
                    [
                        "max",
                        10000000,
                        "Max: $10,000,000"
                    ]
                ]
            },
            "13796_downpayment": {
                "type": "inputText",
                "inputType": "downPayment",
                "fieldId": "downpayment",
                "questionTitle": "How much is your down payment?",
                "includeSlider": true,
                "sliderMaxValue": 8000000,
                "sliderStepValue": 10000,
                "validation": [
                    [
                        "max",
                        8000000,
                        "Max: 80%"
                    ]
                ]
            },
            "13792_incomeSource": {
                "type": "radio",
                "fieldId": "incomeSource",
                "answerOptions": [
                    {
                        "text": "Employed",
                        "value": "Employed"
                    },
                    {
                        "text": "Self-Employed",
                        "value": "Self-Employed"
                    },
                    {
                        "text": "Retired",
                        "value": "Retired"
                    },
                    {
                        "text": "Not Employed",
                        "value": "Not Employed"
                    }
                ]
            },
            "13784_annualIncome": {
                "type": "radio",
                "fieldId": "annualIncome",
                "answerOptions": [
                    {
                        "text": "$200,000+",
                        "value": "$200,000+"
                    },
                    {
                        "text": "$100,000 - $200,000",
                        "value": "$100,000 - $200,000"
                    },
                    {
                        "text": "$50,000 - $100,000",
                        "value": "$50,000 - $100,000"
                    },
                    {
                        "text": "$20,000 - $50,000",
                        "value": "$20,000 - $50,000"
                    },
                    {
                        "text": "Less than $20,000",
                        "value": "Less than $20,000"
                    }
                ]
            },
            "13803_proofOfIncome": {
                "type": "radio",
                "fieldId": "proofOfIncome",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13794_militaryServiceFlag": {
                "type": "radio",
                "fieldId": "militaryServiceFlag",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13785_bankruptcyFlag": {
                "type": "radio",
                "fieldId": "bankruptcyFlag",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13789_forclosureFlag": {
                "type": "radio",
                "fieldId": "forclosureFlag",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13793_lateMortgagePaymentCount": {
                "type": "radio",
                "fieldId": "lateMortgagePaymentCount",
                "answerOptions": [
                    {
                        "text": "None",
                        "value": "None"
                    },
                    {
                        "text": "One Late Payment",
                        "value": "One Late Payment"
                    },
                    {
                        "text": "More Than One",
                        "value": "More Than One"
                    }
                ]
            },
            "13815_hasAgent": {
                "type": "radio",
                "fieldId": "hasAgent",
                "answerOptions": [
                    {
                        "value": "Yes",
                        "text": "Yes"
                    },
                    {
                        "value": "No",
                        "text": "No"
                    }
                ]
            },
            "13786_estimateCreditRating": {
                "type": "radio",
                "fieldId": "estimateCreditRating",
                "answerOptions": [
                    {
                        "text": "Excellent (720+)",
                        "value": "Excellent (720+)"
                    },
                    {
                        "text": "Good (680 – 719)",
                        "value": "Good (680 – 719)"
                    },
                    {
                        "text": "Fair (620 – 679)",
                        "value": "Fair (620 – 679)"
                    },
                    {
                        "text": "Poor (580 - 619)",
                        "value": "Poor (580 - 619)"
                    },
                    {
                        "text": "Below < 580",
                        "value": "Below < 580"
                    }
                ]
            },
            "13791_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13791_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13791_FirstName&LastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "FirstName&LastName"
            },
            "13788_email": {
                "type": "inputText",
                "inputType": "email",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "@",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "13788_Email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Email"
            },
            "13802_phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "13816_state": {
                "type": "dropDown",
                "fieldId": "state",
                "labelText": "",
                "customDefaultText": null,
                "answerOptions": [
                    {
                        "text": "Alabama",
                        "value": "AL"
                    },
                    {
                        "text": "Alaska",
                        "value": "AK"
                    },
                    {
                        "text": "Arizona",
                        "value": "AZ"
                    },
                    {
                        "text": "Arkansas",
                        "value": "AR"
                    },
                    {
                        "text": "California",
                        "value": "CA"
                    },
                    {
                        "text": "Colorado",
                        "value": "CO"
                    },
                    {
                        "text": "Connecticut",
                        "value": "CT"
                    },
                    {
                        "text": "Delaware",
                        "value": "DE"
                    },
                    {
                        "text": "District Of Columbia",
                        "value": "DC"
                    },
                    {
                        "text": "Florida",
                        "value": "FL"
                    },
                    {
                        "text": "Georgia",
                        "value": "GA"
                    },
                    {
                        "text": "Hawaii",
                        "value": "HI"
                    },
                    {
                        "text": "Idaho",
                        "value": "ID"
                    },
                    {
                        "text": "Illinois",
                        "value": "IL"
                    },
                    {
                        "text": "Indiana",
                        "value": "IN"
                    },
                    {
                        "text": "Iowa",
                        "value": "IA"
                    },
                    {
                        "text": "Kansas",
                        "value": "KS"
                    },
                    {
                        "text": "Kentucky",
                        "value": "KY"
                    },
                    {
                        "text": "Louisiana",
                        "value": "LA"
                    },
                    {
                        "text": "Maine",
                        "value": "ME"
                    },
                    {
                        "text": "Maryland",
                        "value": "MD"
                    },
                    {
                        "text": "Massachusetts",
                        "value": "MA"
                    },
                    {
                        "text": "Michigan",
                        "value": "MI"
                    },
                    {
                        "text": "Minnesota",
                        "value": "MN"
                    },
                    {
                        "text": "Mississippi",
                        "value": "MS"
                    },
                    {
                        "text": "Missouri",
                        "value": "MO"
                    },
                    {
                        "text": "Montana",
                        "value": "MT"
                    },
                    {
                        "text": "Nebraska",
                        "value": "NE"
                    },
                    {
                        "text": "Nevada",
                        "value": "NV"
                    },
                    {
                        "text": "New Hampshire",
                        "value": "NH"
                    },
                    {
                        "text": "New Jersey",
                        "value": "NJ"
                    },
                    {
                        "text": "New Mexico",
                        "value": "NM"
                    },
                    {
                        "text": "New York",
                        "value": "NY"
                    },
                    {
                        "text": "North Carolina",
                        "value": "NC"
                    },
                    {
                        "text": "North Dakota",
                        "value": "ND"
                    },
                    {
                        "text": "Ohio",
                        "value": "OH"
                    },
                    {
                        "text": "Oklahoma",
                        "value": "OK"
                    },
                    {
                        "text": "Oregon",
                        "value": "OR"
                    },
                    {
                        "text": "Pennsylvania",
                        "value": "PA"
                    },
                    {
                        "text": "Rhode Island",
                        "value": "RI"
                    },
                    {
                        "text": "South Carolina",
                        "value": "SC"
                    },
                    {
                        "text": "South Dakota",
                        "value": "SD"
                    },
                    {
                        "text": "Tennessee",
                        "value": "TN"
                    },
                    {
                        "text": "Texas",
                        "value": "TX"
                    },
                    {
                        "text": "Utah",
                        "value": "UT"
                    },
                    {
                        "text": "Vermont",
                        "value": "VT"
                    },
                    {
                        "text": "Virginia",
                        "value": "VA"
                    },
                    {
                        "text": "Washington",
                        "value": "WA"
                    },
                    {
                        "text": "West Virginia",
                        "value": "WV"
                    },
                    {
                        "text": "Wisconsin",
                        "value": "WI"
                    },
                    {
                        "text": "Wyoming",
                        "value": "WY"
                    }
                ]
            },
            "13812_propertyType": {
                "type": "radio",
                "fieldId": "propertyType",
                "answerOptions": [
                    {
                        "text": "Single Family Home",
                        "value": "Single Family Home"
                    },
                    {
                        "text": "Multi-Family Home",
                        "value": "Multi-Family Home"
                    },
                    {
                        "text": "Townhouse / Condo",
                        "value": "Townhouse / Condo"
                    },
                    {
                        "text": "Manufactured Home",
                        "value": "Manufactured Home"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13814_refiReason": {
                "type": "radio",
                "fieldId": "refiReason",
                "answerOptions": [
                    {
                        "text": "Cash Out",
                        "value": "Cash Out"
                    },
                    {
                        "text": "Lower Payments",
                        "value": "Lower Payments"
                    },
                    {
                        "text": "Pay Off Faster",
                        "value": "Pay Off Faster"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13811_homeValueAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "homeValueAmt",
                "questionTitle": "What's your home's value?",
                "includeSlider": true,
                "sliderMinValue": 25000,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "required"
                    ],
                    [
                        "min",
                        25000,
                        "Minimum: $25,000"
                    ],
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13805_loanAmt_R": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "loanAmt_R",
                "questionTitle": "How much do you owe?",
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13807_cashOutAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "cashOutAmt",
                "questionTitle": "How much cash do you want to borrow?",
                "includeSlider": true,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "defaultValue": 150000,
                "validation": [
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13790_firstName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "firstName",
                "name": "Textbox | First Name",
                "label": "First Name",
                "autoComplete": "given-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13790_lastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "lastName",
                "name": "Textbox | Last Name",
                "label": "Last Name",
                "autoComplete": "family-name",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 2,
                "maxLength": 50,
                "pattern": "^[A-Za-z]{2}[A-Za-z -]*$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[A-Za-z]{2}[A-Za-z -]*$",
                        "Must start with two letters. Only letters, spaces and hyphens are allowed."
                    ],
                    [
                        "minLength",
                        2,
                        "Min 2 letters"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 letters"
                    ]
                ]
            },
            "13790_FirstName&LastName": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "FirstName&LastName"
            },
            "13813_propertyType": {
                "type": "radio",
                "fieldId": "propertyType",
                "answerOptions": [
                    {
                        "text": "Single Family Home",
                        "value": "Single Family Home"
                    },
                    {
                        "text": "Multi-Family Home",
                        "value": "Multi-Family Home"
                    },
                    {
                        "text": "Townhouse / Condo",
                        "value": "Townhouse / Condo"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13804_loanAmt_R": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "loanAmt_R",
                "questionTitle": "How much do you owe?",
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "validation": [
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13806_cashOutAmt": {
                "type": "inputText",
                "inputType": "currency",
                "fieldId": "cashOutAmt",
                "questionTitle": "How much cash do you want to borrow?",
                "includeSlider": true,
                "sliderMaxValue": 10000000,
                "sliderStepValue": 25000,
                "defaultValue": 150000,
                "validation": [
                    [
                        "max",
                        10000000
                    ]
                ]
            },
            "13808_refiHelocWhy": {
                "type": "radio",
                "fieldId": "refiHelocWhy",
                "answerOptions": [
                    {
                        "text": "Home Improvement",
                        "value": "Home Improvement"
                    },
                    {
                        "text": "Lump Sum of Cash",
                        "value": "Lump Sum of Cash"
                    },
                    {
                        "text": "Pay Higher Interest Debts",
                        "value": "Pay Higher Interest Debts"
                    },
                    {
                        "text": "Finance for Education",
                        "value": "Finance for Education"
                    },
                    {
                        "text": "Other",
                        "value": "Other"
                    }
                ]
            },
            "13787_email": {
                "type": "inputText",
                "inputType": "email",
                "fieldId": "email",
                "name": "Textbox | Email Address",
                "label": "Email Address",
                "placeholder": "@",
                "autoComplete": "email",
                "autoCorrect": "off",
                "spellCheck": "false",
                "maxLength": 50,
                "pattern": "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                "validation": [
                    [
                        "required",
                        "Required"
                    ],
                    [
                        "pattern",
                        "^[a-zA-Z0-9_+-](?:[a-zA-Z0-9._+-])*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
                        "Invalid Email Address"
                    ],
                    [
                        "maxLength",
                        50,
                        "Max 50 characters"
                    ]
                ]
            },
            "13787_Email": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "Email"
            },
            "13801_phone": {
                "type": "inputText",
                "inputType": "text",
                "fieldId": "phone",
                "name": "Textbox | Phone Number",
                "label": "Phone Number**",
                "labelAlt": "Phone Number",
                "placeholder": "(___) ___-____",
                "inputMask": "(999) 999-9999",
                "autoComplete": "tel-national",
                "autoCorrect": "off",
                "spellCheck": "false",
                "minLength": 14,
                "maxLength": 14,
                "pattern": "[(][^01].*",
                "disclosure": "**By entering my phone number above, I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Msg & data rates may apply. Msg frequency varies.",
                "hideDisclosure": true,
                "validation": [
                    [
                        "required",
                        "Phone number is required"
                    ],
                    [
                        "pattern",
                        "[(][^01].*",
                        "Phone area code invalid"
                    ],
                    [
                        "minLength",
                        14,
                        "10-Digit Phone #"
                    ],
                    [
                        "maxLength",
                        14
                    ],
                    [
                        "phone"
                    ]
                ]
            },
            "loanPurpose": {
                "type": "radio",
                "fieldId": "loanPurpose",
                "answerOptions": [
                    {
                        "value": "purchase",
                        "text": "Buy a Home",
                        "customIconImage": "https://images4.cmp.optimizely.com/assets/icon-money-house-white.svg/Zz0wNGM3Yzk3MmE1NDcxMWYwYTg4YmZlODA2M2VkN2E0Zg==",
                        "id": 13756
                    },
                    {
                        "value": "refinance",
                        "text": "Refinance",
                        "customIconImage": "https://images2.cmp.optimizely.com/assets/icon-money-cycle-white.svg/Zz0wNGJjYzBmNGE1NDcxMWYwYmZmYmMyZTM4NmU1NGRmNQ==",
                        "id": 13757
                    },
                    {
                        "value": "equity",
                        "text": "Use My Equity",
                        "customIconImage": "https://images2.cmp.optimizely.com/assets/icon-money-bag-white.svg/Zz0wNGFjMjBiNGE1NDcxMWYwYTEyNjRhMmI3MDczMjYzZA==",
                        "id": 13758
                    }
                ]
            }
        },
        "introDescription": "",
        "customIntroQuestion": "",
        "pageSpecificDisclosures": "",
        "_rid": "cUFDANRpTdkKAAAAAAAAAA==",
        "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkKAAAAAAAAAA==/",
        "_etag": "\"2e00e06c-0000-4d00-0000-69a741090000\"",
        "_attachments": "attachments/",
        "_ts": 1772568841,
        "parentPageCollection": {
            "id": "13820-parent-www",
            "dynamicform": "https://www.newamericanfunding.com/df/",
            "templateType": "parent",
            "defaultPhone": "(855) 276-3747",
            "formDisclosures": "<p>By clicking \"Submit\", I acknowledge that I have reviewed the&nbsp;<a href=\"/link/577ec19b835e45738672b6b71bfde1bf.aspx\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a> and agree by ESIGN signature to the following:</p>\n<ol>\n<li>I am providing written instructions under the Fair Credit Reporting Act authorizing New American Funding (NAF) to obtain information from my personal credit profile or other information from a consumer reporting agency solely to conduct a prequalification for credit.</li>\n<li>Receive disclosures and communications about my loan inquiry and any loan that I obtain from NAF in electronic form. I confirm I have access to a working computer and/or digital device where I can view and manage my information.</li>\n<li>I consent to NAF, its&nbsp;<a href=\"/link/c24b75f81e1c4b30b55992ffefc566b5.aspx\" target=\"_blank\" rel=\"noopener\">partners</a>, and parties calling on their behalf to contact me at the number that I provided on the previous screen for marketing purposes, including through the use of email, automated technology, artificial or prerecorded voice, AI generative voice, and SMS/MMS messages. I acknowledge my consent is not required to obtain any good or service, and that I can be connected with NAF without providing consent by calling <a href=\"tel:+1-800-890-1057\">(800) 890-1057</a>. I consent to be contacted even if my phone number or email address appears on a NAF Do Not Contact/Do Not Email list, a State or National Do Not Call Registry or any other Do Not Contact/Do Not Email list.</li>\n<li>To the terms of NAF's <a href=\"/link/b5dcd8b0e78845529aa30fe9011f9036.aspx\" target=\"_blank\" rel=\"noopener\">Terms of Use</a>&nbsp;and&nbsp;<a href=\"/link/f5695fd0d410420d9271082ca3047d44.aspx\" target=\"_blank\" rel=\"noopener\">Electronic Consent Agreement</a>.</li>\n</ol>",
            "footerDisclosures": {
                "InternalFormat": "<p><strong>By using our site, you agree to our use of cookies. For more information, read our&nbsp;<a href=\"",
                "ReferencedPermanentLinkIds": []
            },
            "_rid": "cUFDANRpTdkJAAAAAAAAAA==",
            "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkJAAAAAAAAAA==/",
            "_etag": "\"21014ca0-0000-4d00-0000-6962aa840000\"",
            "_attachments": "attachments/",
            "_ts": 1768073860
        },
        "rootPageCollection": {
            "id": "15-root-www",
            "dynamicform": "https://www.newamericanfunding.com/",
            "templateType": "root",
            "copyright": "New American Funding, LLC. All Rights Reserved.",
            "corporateOfficeAddress": "1 MacArthur Place, Suite 800, Santa Ana, CA 92707",
            "legalLinks": [
                {
                    "Text": "NMLS ID#6606",
                    "Href": "https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/6606"
                },
                {
                    "Text": "State Licensing",
                    "Href": "https://www.newamericanfunding.com/legal/state-licensing/"
                },
                {
                    "Text": "Privacy Policy",
                    "Href": "https://www.newamericanfunding.com/legal/privacy-policy/"
                },
                {
                    "Text": "Terms of Use",
                    "Href": "https://www.newamericanfunding.com/legal/terms-of-use/"
                },
                {
                    "Text": "Terms of Use for Serviced Loans",
                    "Href": "https://www.newamericanfunding.com/legal/terms-of-use-for-serviced-loans/"
                },
                {
                    "Text": "Advertising Disclosures",
                    "Href": "https://www.newamericanfunding.com/legal/advertising-disclosures/"
                },
                {
                    "Text": "Electronic Consent Agreement",
                    "Href": "https://www.newamericanfunding.com/legal/electronic-consent-agreement/"
                },
                {
                    "Text": "Partners",
                    "Href": "https://www.newamericanfunding.com/legal/partners/"
                },
                {
                    "Text": "On-Time Closing Guarantee",
                    "Href": "https://www.newamericanfunding.com/legal/on-time-closing-guarantee/"
                },
                {
                    "Text": "NMLS Consumer Access",
                    "Href": "https://www.nmlsconsumeraccess.org/"
                },
                {
                    "Text": "State Disclosures for Serviced Loans",
                    "Href": "https://www.newamericanfunding.com/legal/state-disclosures-for-serviced-loans/"
                },
                {
                    "Text": "Cookie Policy",
                    "Href": "https://www.newamericanfunding.com/legal/cookie-policy/"
                },
                {
                    "Text": "California Collection Notice",
                    "Href": "https://www.newamericanfunding.com/legal/privacy-policy/#CAnotice"
                },
                {
                    "Text": "CA Privacy Policy",
                    "Href": "https://www.newamericanfunding.com/legal/ca-privacy-policy/"
                }
            ],
            "adaDisclosure": "If you are using a screen reader or other auxiliary aid and are having problems using this website, please call <a href=\"tel:800-450-2010\">800-450-2010</a> Ext. 7100 for assistance.",
            "_rid": "cUFDANRpTdkIAAAAAAAAAA==",
            "_self": "dbs/cUFDAA==/colls/cUFDANRpTdk=/docs/cUFDANRpTdkIAAAAAAAAAA==/",
            "_etag": "\"2e00da6c-0000-4d00-0000-69a73f360000\"",
            "_attachments": "attachments/",
            "_ts": 1772568374
        }
    }
};
